import React, { useContext, useEffect } from 'react';
import { CollectionContext } from '../context';
import { SketchPicker } from "react-color";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { CollectionBanner, CollectionEditState } from '../../../../types/collections';

import { FILTERS } from '../../../../constants/banner';
import { BannerView } from '../../../../components/banner';

import _ from 'lodash';
import styles from './banner.module.scss';

interface BannerFiltersProps {
  collection: CollectionEditState;
}

const BannerFilters: React.FC<BannerFiltersProps> = ({ collection }) => {
  const collectionContext = useContext(CollectionContext);

  const banner = collection.banner;
  const [originalBanner, setOriginalBanner] = React.useState({
    filter: banner?.filter,
    overlayColor: banner?.overlayColor,
  });

  useEffect(() => {
    setOriginalBanner({
      filter: banner?.filter,
      overlayColor: banner?.overlayColor,
    });
  }, []);

  const updateFilters = (value : any) => {
    collectionContext.updateCollectionProperty('banner', {
      ...banner,
      ...value,
    });
  }

  const handleClick = (value: any) => {
    updateFilters(value);
    setOriginalBanner(value);
  }
  
  const handleMouseOver = (value: any) => { 
    updateFilters(value);
  }

  const handleMouseOut = () => {
    updateFilters({
      filter: originalBanner?.filter,
      overlayColor: originalBanner?.overlayColor,
    });
  }

  const getColor = (value: any) => {
    const r = _.get(value, 'r', 0);
    const g = _.get(value, 'g', 0);
    const b = _.get(value, 'b', 0);
    const a = _.get(value, 'a', 1);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  };

  if(!banner) {
    return null;
  }

  return (
    <div className={styles.bannerFilters}>
      <div className={styles.filterHeader}>
        <h2 className={styles.filterTitle}>
          Choose the filter you want to apply
        </h2>

        {originalBanner?.overlayColor && originalBanner?.filter === banner?.filter && (
          <div className={styles.dropdownWrapper}>
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              rootClose
              overlay={
                <Popover id="popover-color-picker" className={styles.sketchPickerPopover}>
                  <Popover.Body>
                    <SketchPicker
                      color={banner.overlayColor}
                      onChangeComplete={(color) => {
                        const updatedOverlayColor = color.rgb;
                        updateFilters({ overlayColor: updatedOverlayColor });
                        setOriginalBanner((prev) => ({
                          ...prev,
                          overlayColor: updatedOverlayColor,
                        }));
                      }}
                    />
                  </Popover.Body>
                </Popover>
              }
            >
              <div className={styles.colorTrigger}>
              <button
                style={{
                  backgroundColor: getColor(banner.overlayColor),
                }}
                className={styles.changeColorButton}
              />
              <span className={styles.changeColorText}>change color</span>
              </div>
            </OverlayTrigger>
          </div>
        )}
      </div>
      
      <div className={styles.filters}>
        {FILTERS.map((filter) => {

          const bannerItem = {
            ...banner!,
            ...filter.value,
            filter: filter.value.filter ?? undefined,
          } as unknown as CollectionBanner;

          return (
            <div key={filter.label} className={styles.filter} 
              onClick={() => {
                handleClick(filter.value);
              }}
              onMouseOver={() => handleMouseOver(filter.value)}
              onMouseOut={handleMouseOut}
            >
              <BannerView banner={bannerItem} height={200} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export { BannerFilters };